import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";

import { SupportedSources } from "@app/enum/SourceType";
import CardConfiguration, {
  DefaultDateRangeConfiguration,
} from "@app/types/dashboard/CardConfiguration";
import BasePreferences from "@app/types/dashboard/cards/BasePreferences";

export enum ActivitiesLoggedAggregationType {
  SUM = "SUM",
  AVG = "AVG",
}

export interface ActivitiesLoggedCriteria {
  activityTypeIds: ActivityType["id"][];
  aggregationType: ActivitiesLoggedAggregationType;
  sources: SupportedSources[];
}

export default interface ActivitiesLoggedCardConfiguration extends CardConfiguration<
  ActivitiesLoggedCriteria,
  DefaultDateRangeConfiguration,
  BasePreferences
> {}
